import { PropsWithChildren } from 'react';
import { TransparentBottomBar } from '../Layouts/TransparentBottomBar';

/**
 * Claim CTA for a campaign page: fixed to the bottom on mobile, last item on desktop.
 * Rendered in the claim slot above the coupons (forms and success cards belong there),
 * so `order-last` is what moves the button below the coupon list on desktop.
 */
export const CampaignClaimBottomBar = ({ children }: PropsWithChildren) => (
  <TransparentBottomBar className='md:order-last md:mt-0 md:flex md:justify-end'>{children}</TransparentBottomBar>
);
